import { Injectable } from '@angular/core';
import { ProductModelSearchAdapter } from './product-model-search.adapter';
import { Observable } from 'rxjs';
import { ManualsSearchResults } from '../../model/product.model';

@Injectable()
export class ProductModelSearchConnector {
  constructor(protected adapter: ProductModelSearchAdapter) {}

  suggest(insertedModelMark: string): Observable<string> {
    return this.adapter.suggest(insertedModelMark);
  }

  find(insertedModelMark: string): Observable<string> {
    return this.adapter.find(insertedModelMark);
  }

  findManuals(query: string | null | undefined): Observable<ManualsSearchResults> {
    return this.adapter.findManuals(query);
  }
}
